import React, { useState } from 'react';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    { q: 'What is ABVIG?', a: 'ABVIG is a premier business organization connecting African businesses with global investment opportunities.' },
    { q: 'How do I become a member?', a: 'You can apply through our membership page or contact us directly for more information.' },
    { q: 'What events does ABVIG organize?', a: 'We organize AICIS Summits, Business & Investment Forums, and Trade Missions.' },
    { q: 'Do you offer business incubation?', a: 'Yes, we have a comprehensive business incubator program for startups.' },
    { q: 'How can I contact ABVIG?', a: 'You can reach us through our contact page, or call our Africa Secretariat at +234 703 294 1519.' },
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div>
      <section className="page-hero">
        <h1>Frequently Asked Questions</h1>
        <p>Find answers to common questions</p>
      </section>
      <section className="page-content">
        <div className="container">
          <div className="faq-list">
            {faqs.map((faq, index) => (
              <div className="faq-item" key={index}>
                <div className="faq-question" onClick={() => toggleFAQ(index)}>
                  <h3>{faq.q}</h3>
                  <span className="faq-toggle">{openIndex === index ? '−' : '+'}</span>
                </div>
                {openIndex === index && (
                  <div className="faq-answer">
                    <p>{faq.a}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default FAQ;